import { Select } from 'foundations-components/transitional/components/Select';
import FormattedMessage from 'I18n/components/FormattedMessage';
import I18n from 'I18n';
import { jsx as _jsx } from "react/jsx-runtime";
const ButtonContent = ({
  count
}) => {
  if (count > 0) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "learningCenter.myTeam.filters.certificationStatus.buttonLabelCount",
      options: {
        count
      }
    });
  }
  return /*#__PURE__*/_jsx(FormattedMessage, {
    message: "learningCenter.myTeam.filters.certificationStatus.buttonLabel"
  });
};
const getStatusOptions = () => [{
  text: I18n.text('learningCenter.myTeam.filters.certificationStatus.active'),
  value: 'ACTIVE'
}, {
  text: I18n.text('learningCenter.myTeam.filters.certificationStatus.expired'),
  value: 'EXPIRED'
}, {
  text: I18n.text('learningCenter.myTeam.filters.certificationStatus.inProgress'),
  value: 'IN_PROGRESS'
}];
const CertificationStatusFilter = ({
  onChange,
  selectedCertificationStatuses
}) => {
  return /*#__PURE__*/_jsx(Select, {
    ButtonContent: ButtonContent,
    anchorType: "button",
    buttonContentProps: {
      count: selectedCertificationStatuses.length
    },
    buttonUse: "transparent",
    "data-test-id": "certification-status-filter",
    menuWidth: 200,
    multi: true,
    onChange: evt => {
      onChange(evt.target.value);
    },
    options: getStatusOptions(),
    value: selectedCertificationStatuses
  });
};
export default CertificationStatusFilter;